import { checkIsMobileScreenAction } from 'actions/mobile';
import { connect, ConnectedProps } from 'react-redux';

const mapDispatchToProps = { checkIsMobileScreenAction };

export const connector = connect(null, mapDispatchToProps);

export type Props = ConnectedProps<typeof connector>;
